import { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { BodyWrapper, Header, Loader, MainWrapper, Message } from '@components';
import { blogCategoriesQuery, authorMutation, siteQuery } from '@queries';
import { ChevronRightIcon, SearchIcon } from '@svgs';

import AuthorForm from '../components/AuthorForm/AuthorForm.jsx';
import { SiteBreadcrumbs } from '../components/SiteBreadcrumbs/SiteBreadcrumbs.jsx';
import SiteSidebar from '../components/SiteSidebar/SiteSidebar.jsx';

export const AddAuthor = () => {
  const { t, i18n } = useTranslation();
  const { siteID } = useParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  // get site
  const { data: siteData, isPending: siteIsPending } = useQuery(
    siteQuery(siteID),
  );

  // save author
  const mutation = useMutation(
    authorMutation(null, {
      onSuccess: (data) => {
        // invalidate the lists so its purged
        queryClient.invalidateQueries({ queryKey: ['authors', 'list'] });
        // navigate to the edit view
        navigate(`/dashboard/sites/${siteID}/blogs/authors/${data.id}`);
      },
    }),
  );

  const defaultAuthor = {
    site_id: siteID,
  };

  return (
    <>
      <Header />
      <BodyWrapper>
        <SiteSidebar siteID={siteID} siteData={siteData} />
        <MainWrapper>
          <SiteBreadcrumbs siteData={siteData}>
            <li className="sb-flex">
              <Link to={`/dashboard/sites/${siteID}/blogs`}>Blogs</Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">
              <Link to={`/dashboard/sites/${siteID}/blogs/authors`}>
                {t('Blog authors')}
              </Link>
              <ChevronRightIcon />
            </li>
            <li className="sb-flex">
              <span>Add</span>
            </li>
          </SiteBreadcrumbs>
          <div className="sb-manage-content">
            <AuthorForm
              authorData={defaultAuthor}
              mutation={mutation}
              disabled={mutation.isPending}
              onCancel={() => {
                navigate(`/dashboard/sites/${siteID}/blogs/authors`);
              }}
            />
          </div>
        </MainWrapper>
      </BodyWrapper>
    </>
  );
};
